import React, { useState } from "react";
// import { useHistory } from "react-router-dom";
import BillingTable from "../../Components/DataTables/BillingTable";
import Button from "../../Components/UI/Button/Button";
// import ButtonWithBG from "../../Components/UI/ButtonMain";
import SearchField from "../../Components/UI/SearchField";
import DashBoardLayout from "../../Layouts/private/DashboardLayout";
// import { SEARCH_PLACEHOLDER } from "../../Utils/Constants";
import { setting_svg } from "../../Utils/SVGListing";

const Billing = () => {
  // let history = useHistory();
  const [searchValue, setSearchValue] = useState("");

  // To redirect to add page
  // const redirectToAdd = () => {
  //   history.push({
  //     pathname: "/billing/add-edit-billing",
  //     state: { label: "Add" },
  //   });
  // };
  return (
    <DashBoardLayout pageTitle="Billing">
      <div className="min-w-full space-y-4">
        {/* <Divider subtitle="Pending Booking" /> */}
        {/* Search and setting */}
        <div className="flex flex-row justify-between ">
          <div>
            <SearchField
              placeholder="Searching By Bill No."
              handleChange={setSearchValue}
              value={searchValue}
            />
          </div>
          <div className="flex flex-row space-x-2  items-start">
            <Button svg={setting_svg}></Button>
            {/* <ButtonWithBG
              handleClick={redirectToAdd}
              theme="primary"
              label="Add Billing"
            /> */}
          </div>
        </div>
      </div>
      <BillingTable searchValue={searchValue} />
    </DashBoardLayout>
  );
};

export default Billing;
